<template>
    <div class="wc-wrap">

        <div class="wc-header">
            <div class="wc-title" @click="openChecklistTab('workcentre_id', workcentre.id)" :title="'Open Checklist for ' + workcentre.name">
                <div class="wc-title-name">{{ workcentre.name }}</div>
                <div :class="['wc-percent-filled', wcPercentFilledClass]" :title="wcPercentFilledTitle">{{ wcPercentFilled }}%</div>
            </div>
            <div class="wc-users-wrap">
                <div v-for="user in sortedUsers"
                     :key="user.id"
                     :class="['stat', 'small-stat', 'user-badge', 'wc-user', percentFilledClass(user.percent_filled)]"
                     :title="percentFilled(user.percent_filled) + ' ' + percentFilledTitle(user.mins_required, user.mins_capacity)"
                     :data-backup-style="{
                         backgroundColor: expanded ? user.badgeCss['background-color'] : '#fff',
                         border: '1px solid ' + (expanded ? user.badgeCss['border-color'] : '#c8c8c8'),
                         color: expanded ? user.badgeCss['color'] : '#4f4f4f',
                    }"
                     @click="openChecklistTab('user_id', user.id)"
                >
                    {{ user.name }}
                </div>
            </div>
        </div>

        <div class="wc-stat-big-mode wc-stats-wrap">

            <div class="wc-stats-col" :style="'background-color: ' + todoBgColor">
                <div class="wc-stat-title">To Do</div>
                <div class="wc-stat-big" v-html="formatHtmlMins(workcentre.status_totals.to_do.mins_required)"></div>
            </div>

            <div class="wc-stats-col" :style="'background-color: ' + doneBgColor">
                <div class="wc-stat-title">Done</div>
                <div class="wc-stat-big" v-html="formatHtmlMins(workcentre.status_totals.done.mins_required)"></div>
            </div>

            <div class="wc-stats-col" :style="'background-color: ' + freeBgColor">
                <div class="wc-stat-title">Free</div>
                <div class="wc-stat-big" v-html="formatHtmlMins(workcentre.mins_free)"></div>
            </div>

        </div>

        <div class="wc-stats-info" v-if="expanded">

            <div class="wc-stats-row wc-stats-row-section-head">
                <div class="wc-stats-row-title">Scheduled</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.status_totals.scheduled.mins_required)"></div>
            </div>
            <div class="wc-stats-row">
                <div class="wc-stats-row-title wc-stats-row-title-space-1">To Do</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.status_totals.to_do.mins_required)"></div>
            </div>
            <div class="wc-stats-row">
                <div class="wc-stats-row-title wc-stats-row-title-space-2">Blocked</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.status_totals.blocked.mins_required)"></div>
            </div>
            <div class="wc-stats-row">
                <div class="wc-stats-row-title wc-stats-row-title-space-2">In Progress</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.status_totals.in_progress.mins_required)"></div>
            </div>
            <div class="wc-stats-row">
                <div class="wc-stats-row-title wc-stats-row-title-space-1">Done</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.status_totals.done.mins_required)"></div>
            </div>
            <div class="wc-stats-row wc-stats-row-section-head">
                <div class="wc-stats-row-title">Capacity</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.mins_capacity)"></div>
            </div>
            <div class="wc-stats-row" v-for="user in sortedUsers" :key="user.id">
                <div class="wc-stats-row-title wc-stats-row-title-space-1">{{ user.name }}</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(user.mins_capacity)"></div>
            </div>
            <div class="wc-stats-row wc-stats-row-section-head">
                <div class="wc-stats-row-title">Free</div>
                <div class="wc-stats-row-value" v-html="formatHtmlMins(workcentre.mins_free)"></div>
            </div>
            <div class="wc-stats-row wc-stats-row-section-head">
                <div class="wc-stats-row-title">Filled</div>
                <div class="wc-stats-row-value">{{ wcPercentFilled }}%</div>
            </div>

        </div>

        <div class="wc-expand-bar" @click="toggleExpand()" :title="(expanded ? 'Contract' : 'Expand')">
            <i v-if="expanded" class="fas fa-caret-up"></i>
            <i v-else class="fas fa-caret-down"></i>
        </div>

    </div>
</template>


<script>

import {default as _} from "lodash";
import api from "../../api";

export default {

    props: {
        workcentre: {
            type: Object,
            required: true,
        },
        totals: {
            type: Object,
            required: true,
        },
        // will default to false, including when not set.
        expanded: Boolean,
    },

    data: () => ({
        loading: false,
        //expanded: false,
    }),

    mounted() {},

    components: {},

    methods: {
        toggleExpand() {
              this.expanded = !this.expanded;
        },
        maybePlural(count, singular, plural) {
            return count === 1 ? singular : plural;
        },
        openChecklistTab(filter, id) {

            // Change Misc id so it shows on page load for a title click
            id = filter === 'workcentre_id' && id === 0 ? 99999 : id;

            let url = window.location.href.replace('workcentre-dashboard', 'checklist');
            url += '?' + filter + '=' + id;

            window.open(url, '_blank');
        },
        percentFilled(percent) {
            return percent === 999 ? '∞' : percent;
        },
        percentFilledTitle(mins_required, mins_capacity) {
            return 'Percent filled: '
                + this.$options.filters.format_mins_decimal(mins_required)
                + ' scheduled / '
                + this.$options.filters.format_mins_decimal(mins_capacity)
                + ' capacity';
        },
        percentFilledClass(percent) {
            if (percent <= 50)
                return 'wc-percent-low';
            else if (percent <= 100)
                return 'wc-percent-medium';
            else if (percent <= 150)
                return 'wc-percent-high';
            else
                return 'wc-percent-omg';
        },
        formatHtmlMins(value) {
            return value <= 0 ? '<span>-</span>' : this.$options.filters.format_mins_decimal(value);
        }
    },

    computed: {
        wcPercentFilled() {
            return this.percentFilled(this.workcentre.percent_filled);
        },
        wcPercentFilledTitle() {
            return this.percentFilledTitle(this.workcentre.mins_required, this.workcentre.mins_capacity);
        },
        wcPercentFilledClass() {
            return this.percentFilledClass(this.workcentre.percent_filled);
        },
        sortedUsers() {
            return this.workcentre.users.length ? _.sortBy(this.workcentre.users, ['name']) : [];
        },
        todoBgColor() {
            return 'RGB(255, 179, 0, ' + this.workcentre.status_totals.to_do.mins_required_percent + ')';
        },
        doneBgColor() {
            return 'RGB(23, 202, 35, ' + this.workcentre.status_totals.done.mins_required_percent + ')';
        },
        freeBgColor() {
            return 'RGB(10, 180, 247, ' + this.workcentre.percent_mins_free + ')';
        },
    },
}
</script>

<style>

    .wc-stats-info {
        display: flex;
        margin: 20px 1%;
        width: 98%;
        min-height: 150px;
        border-radius: 3px;
        align-self: flex-start;
        padding: 2px;
        flex-direction: column;
    }
    .wc-stats-row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 3px 0;
        padding-left: 30px;
        font-size: 15px;
    }
    .wc-stats-row-section-head {
        margin-top: 20px;
        font-weight: bold;
        font-size: 16px;
        border-bottom: 1px solid #bdbdbd;
    }
    .wc-stats-row-title {
        width: 50%;
    }
    .wc-stats-row-title-space-1 {
        padding-left: 20px;
    }
    .wc-stats-row-title-space-2 {
        padding-left: 40px;
    }
    .wc-stats-row-value {
        width: 50%;
        text-align: center;
    }

    .wc-wrap {
        border: 1px solid #7b7b7b;
        display: flex;
        margin: 1%;
        width: 31%;
        flex-direction: column;
        justify-content: space-between;
        min-height: 150px;
        border-radius: 3px;
        align-self: flex-start;
        padding: 2px;
    }
    .wc-header {
        display: flex;
        width: 100%;
        flex-direction: column;
        margin: 0 0 10px 0;
    }
    .wc-title {
        font-size: 16px;
        font-weight: bold;
        padding: 6px 12px;
        border-bottom: 1px solid #7b7b7b;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
    }
    .wc-title-name {

    }
    .wc-percent-filled {
        color: #000;
        font-size: 15px;
        border: 1px solid black;
        border-radius: 3px;
        padding: 1px 5px;
        background-color: #ececec;
    }

    .wc-percent-low {
        background-color: #53ad56;
        border-color: #49964c;
        color: #fff;
    }
    .wc-percent-medium {
        background-color: #fff04c;
        border-color: #CEBC31;
        color: #000;
    }
    .wc-percent-high {
        background-color: #E87171;
        border-color: #7C1818;
        color: #fff;
    }
    .wc-percent-omg {
        background-color: #f20909;
        border-color: #aa1717;
        color: #fff;
    }

    .wc-users-wrap {
        padding: 7px 12px 3px 12px;
        min-height: 32px;
    }
    .wc-user {
        margin-top: 8px;
        cursor: pointer;
    }
    .wc-stats-wrap {
        display: flex;
        justify-content: space-evenly;
        margin: 0 0 10px 0;
    }
    .wc-stats-col {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 9px;
        margin: 0 2px;
        border-radius: 3px;
    }
    .wc-stat-title {
        font-weight: bold;
        white-space: nowrap;
        font-size: 15px;
        margin-bottom: 11px;
        padding-left: 10px;
    }
    .wc-stat {
        font-size: 14px;
        padding-left: 10px;
        margin: 4px 0;
    }
    .wc-stat span {
        font-weight: bold;
        font-size: 16px;
    }
    .wc-stat-big {
        font-weight: bold;
        font-size: 18px;
        padding-left: 10px;
        margin: 4px 0;
    }
    .wc-stat-big span {
        color: #999;
    }
    .wc-stat-big-mode {
        text-align: center;
    }
    .wc-stat-big-mode .wc-stat-title,
    .wc-stat-big-mode .wc-stat-big
    {
        padding-left: 0;
    }
    .wc-expand-bar {
        border-top: 1px solid #7b7b7b;
        height: 19px;
        width: 100%;
        text-align: center;
        font-size: 21px;
        cursor: pointer;
    }
    .wc-expand-bar i {
        margin: -2px 0 0 0;
        display: block;
    }


</style>